require('./brokerSearchWidgetResult.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getCityOfMarket } = require('utilities/micCodeHelper');
const { formatNumber } = require('utilities/currencyHelper');

// @components
const Flag = require('components/broker/commons/flag/flag');
const { OKLink } = require('commonsComponents/OKLink');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @actions
const morningstarPlansDgsCodeToSecIDActions = require('actions/morningstarPlansDgsCodeToSecID.js');
const brokerSimpleSearchTaggingActions = require('actions/brokerSimpleSearchTagging');

// @constants
const {
    TYPE_WARRANTS,
    TYPE_STOCKS,
    TYPE_ETFS,
    TYPE_PLANS,
    TYPE_FUNDS,
    BROKER_SMALL_FLAG_SIZE,
    PERCENTAGE_SYMBOL,
    BROKER_PRODUCT_ADVANCED_SEARCH_TERM,
    BROKER_HIRE_PENSION_PLAN_URL,
    ALTERNATIVE_FUNDS
} = require('constants/index');

class BrokerSearchWidgetResult extends React.Component {

    constructor(props) {
        super(props);
        this.handleOnClick = this.handleOnClick.bind(this);
        this.handleOnClickProducts = this.handleOnClickProducts.bind(this);
    }

    getMarketId(result) {
        const { type } = this.props;
        switch (type) {
            case TYPE_STOCKS:
                return result.get('ticker');
            case TYPE_PLANS:
                return result.get('dgsCode');
            case TYPE_ETFS:
            case TYPE_FUNDS:
            case TYPE_WARRANTS:
            case ALTERNATIVE_FUNDS:
                return result.get('isin');
        }
    }

    boldTerm(shortName, searchTerm) {
        let withTermInBold;
        const term = searchTerm.trim();
        const termIndex = shortName.search(new RegExp(term.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i'));

        if (termIndex !== -1) {
            const leftPart = shortName.slice(0, termIndex);
            const rightPart = shortName.slice(termIndex + term.length, shortName.length);
            const untouchedTerm = shortName.slice(termIndex, termIndex + term.length);

            withTermInBold = (
                <div>
                    {leftPart}
                    <span className="broker-search-widget-result__left-info--term">{untouchedTerm}</span>
                    {rightPart}
                </div>
            );

        } else {
            withTermInBold = (
                <div>
                    {shortName}
                </div>
            );
        }

        return withTermInBold;
    }

    handleOnClick() {
        const { history, result, getDgsCodeToSecIDURL} = this.props;
        this.props.trackClickProductEvent();
        if(__CONTACT_CENTER__) {
            history.push(BROKER_HIRE_PENSION_PLAN_URL + result.get('customInstitutionSecurityId'))
        }
        else {
            getDgsCodeToSecIDURL(result.get('dgsCode'));
        }
    }

    handleOnClickProducts() {
        const { history, result } = this.props;
        this.props.trackClickProductEvent();
        history.push(result.get('link'));
    }

    buildSearchResultLeftInfo() {
        const { result, type, immBrokerProductFiltersSearch } = this.props;
        const term = immBrokerProductFiltersSearch.getIn(['search', BROKER_PRODUCT_ADVANCED_SEARCH_TERM])

        const market = result.get('market');
        const countryCode = result.get('country');
        let marketloc; let flag; let content;
        const marketId = this.getMarketId(result);
        const shortName = this.boldTerm(result.get('shortName'), term)

        if (result.get('market')) { //@hardcoded until it is modified in the service by null
            marketloc = ' ' + getCityOfMarket(market) + ', ' + countryCode + ' | ';
            flag = <Flag countryCode={countryCode} pixelsSize={BROKER_SMALL_FLAG_SIZE} />;
        }
        const marketInfo = <div className="broker-search-widget-result__left-info-isin"> {flag}{marketloc}{marketId} </div>

        if(type === TYPE_PLANS) {
            content = (
                <div className="broker-search-widget-result__left-info--shortname">
                    <OKLink onClick={this.handleOnClick}>{shortName}</OKLink>
                </div>
            );
        } else {
            content = (
                <div className="broker-search-widget-result__left-info--shortname">
                    <OKLink onClick={this.handleOnClickProducts}>{shortName}</OKLink>
                </div>
            );
        }

        return (
            <div className="broker-search-widget-result__left-info">
                {content}
                {marketInfo}
            </div>
        );
    }

    getTextQuotation() {
        const { type } = this.props;

        switch (type) {
            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
                return "broker-rightsQuotation";
            case TYPE_PLANS:
            case ALTERNATIVE_FUNDS:
                return "brokerSearchWidget-brokerSearchWidget_minInvestment";
            case TYPE_FUNDS:
                return "brokerSearchWidget-brokerSearchWidget_liquidationValue";
        }
    }

    getDateTimeLastVariation(result) {
        const { type } = this.props;
        const date = result.get('quotationDate');
        const hour = result.get('quotationTime');

        switch (type) {
            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
                return `${date} | ${hour} ${formatText("brokerAdvancedSearch-brokerAdvancedSearch_hour")}`
            case TYPE_PLANS:
            case TYPE_FUNDS:
                return date;
            case ALTERNATIVE_FUNDS:
                return formatText("brokerAlternativeFundsBuy-rentability_tooltipContent")
        }
    }

    buildSearchResultRightInfo() {
        const { result } = this.props;
        const dateTimeLastVariation = this.getDateTimeLastVariation(result);
        const type = result.get('productCategory');
        const quotation =
          type === ALTERNATIVE_FUNDS ? result.get('minInvestment') : result.get('quotation');
        const dayChangePercentage =
          type === ALTERNATIVE_FUNDS
            ? result.get('lastYearReturnValue')
              ? result.get('lastYearReturnValue')
              : '-'
            : formatNumber(result.get('dayChangePercentage'));

        return (
            <div className="broker-search-widget-result__right-info">
                <div className="broker-search-widget-result__right-info-text">
                    <FormattedText value={this.getTextQuotation()} />
                </div>
                <div className="broker-search-widget-result__rigth-info-price">
                    {quotation} {result.get('currency')}
                </div>
                <div className="broker-search-widget-result__rigth-info-variation">
                    <div className="broker-search-widget-result__rigth-info-percentage">
                        <FormattedText value="brokerSearchWidget-lastVariationLabel"/>
                        {`${dayChangePercentage} ${PERCENTAGE_SYMBOL} `}
                    </div>
                    <div className="broker-search-widget-result__rigth-info-tooltip">
                        <OKTooltip
                            content={dateTimeLastVariation}
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const searchResultLeftInfo = this.buildSearchResultLeftInfo();
        const searchResultRightInfo = this.buildSearchResultRightInfo();

        return (
            <div className="broker-search-widget-result">
                {searchResultLeftInfo}
                {searchResultRightInfo}
            </div>
        );
    }
}

BrokerSearchWidgetResult.propTypes = {
    history: PropTypes.object.isRequired,
    result: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    getDgsCodeToSecIDURL: PropTypes.func,
    trackClickProductEvent: PropTypes.func,
    immBrokerProductFiltersSearch: PropTypes.object.isRequired
};

module.exports.constructor = BrokerSearchWidgetResult;
module.exports.BrokerSearchWidgetResult = connect(
    state => ({
        immBrokerProductFiltersSearch: state.brokerProductFiltersSearch
    }),{
        getDgsCodeToSecIDURL: morningstarPlansDgsCodeToSecIDActions.getDgsCodeToSecIDURL,
        trackClickProductEvent: brokerSimpleSearchTaggingActions.trackClickProductEvent
    }
)(withRouter(BrokerSearchWidgetResult));
